const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductShotHistoryQuery = {
    GetProductShotHistory: Backofficebff + '/v1/product-shot-history',
};
